import { format } from 'date-fns-tz';

import { type BookingWindow } from '@service-initiation/shared-clients-tech-care-services';
import { type AppointmentDate } from '@service-initiation/tech-care-data-access-tech-care-services';

export const convertRemoteTechAvailableWindowsToTimeSlots = (
  windows: BookingWindow[]
): AppointmentDate[] => {
  const windowTimeFormat = 'yyyy-MM-dd haaa';
  const localWindows = windows.map((w) => ({
    ...w,
    window_end: format(
      new Date(`${w.window_end.split(' ').join('T')}Z`),
      windowTimeFormat
    ).toString(),
    window_start: format(
      new Date(`${w.window_start.split(' ').join('T')}Z`),
      windowTimeFormat
    ).toString(),
  }));
  const windowDates = localWindows.reduce(function (rv, x) {
    (rv[x.window_start.split(' ')[0]] =
      rv[x.window_start.split(' ')[0]] || []).push(x);
    return rv;
  }, Object.create(null));
  return Object.keys(windowDates).map((wdk) => ({
    availableTimes: windowDates[wdk].map((wd: BookingWindow) => ({
      end: wd.window_end.split(' ')[1],
      start: wd.window_start.split(' ')[1],
    })),
    date: wdk.replace(/-/g, '/'),
    isDisabled: false,
  }));
};
